module.exports = __webpack_public_path__ + "static/img/hq_weixin.340993ea.gif";